import { render, staticRenderFns } from "./SASBTocViewer.vue?vue&type=template&id=3e9bbd1b"
import script from "./SASBTocViewer.vue?vue&type=script&lang=js"
export * from "./SASBTocViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports